import { Component, OnInit, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ActionButtonComponent } from "../../shared/action-button/action-button.component";
import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-user-management",
	templateUrl: "./user-management.component.html",
	styleUrls: ["./user-management.component.scss"],
	imports: [FormsModule, ActionButtonComponent]
})
export class UserManagementComponent implements OnInit {
	private api = inject(ApiService);

	organizations: APIResults.Organization[];
	addorganization = {
		name: ""
	};
	adduser = {
		organization: <APIResults.Organization | undefined>undefined,
		email: "",
		password: "",
		role: <string | undefined>"user"
	};

	async ngOnInit() {
		await this.UpdateOrganizations();
	}

	async AddOrganization() {
		if (this.addorganization.name) {
			await this.api.AddOrganization(this.addorganization.name)
			this.addorganization.name = "";
			await this.UpdateOrganizations();
		}
	}

	async UpdateOrganizations() {
		const orgs = await this.api.GetOrganizations()
		this.organizations = orgs;
	}

	async AddUser() {
		if (this.adduser.organization && this.adduser.email && this.adduser.password && this.adduser.role) {
			await this.api.AddUser(this.adduser.organization.organization_id, this.adduser.email, this.adduser.password, this.adduser.role);
			this.adduser.organization = undefined;
			this.adduser.email = "";
			this.adduser.password = "";
			this.adduser.role = "user";
		}
	}

}
